// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

import apiServices from "../../../../services/apiServices";

export default {
  state: {
    profile: Object
  },
  mutations: {
    SET_USER_NAME_ENTITY(state, value) {
      state.profile = value;
    }
  },
  actions: {
    getEntity(context) {

      return apiServices
        .getEntities()
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_USER_NAME_ENTITY", obj.message[0]);
            }
          }
        })
        .catch(function() {})
        .finally(function() {
          // eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getUserNameEntity(state) {
      return state.profile.Entidade;
    },
    getNIF(state) {
      return state.profile.NIF;
    },
    getAvatar(state) {
      return state.profile.Avatar;
    },
    getOwnerFirstName(state) {
      return state.profile.PrimeiroNome;
    },
    getOwnerFullName(state) {
      return state.profile.PrimeiroNome + " " + state.profile.UltimoNome;
    },
    getEntityAddress(state) {
      return state.profile.Endereco;
    },
    getEntityCellphone(state) {
      return state.profile.CelularEmpresa;
    },
    getEntityTelephone(state) {
      return state.profile.TelefoneEmpresa;
    }
  }
};
